export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'center',
    width: 70,
    fixed: 'left',
    slots: { default: 'opt' },
  },
  {
    title: '订单编号',
    field: 'orderNo',
    headerAlign: 'center',
    align: 'center',
    minWidth: 200,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: '三方订单编号',
    field: 'providerOrderNo',
    headerAlign: 'center',
    align: 'center',
    minWidth: 200,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'v_orderBizStatus',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    title: '订单业务状态',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: '推送类型',
    field: 'pushType',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: '推送状态',
    field: 'pushStatus',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'pushStatus' },
  },
  {
    field: 'pushTime',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    title: '推送时间',
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
